<br />
<div class="row">
  <div class="col-md-10 offset-md-2 text-left  col-12">
    <h1 class="title">
      <span>ACCOUNT CONFIRM INFORMATION</span>
    </h1>
  </div>
</div>
<br />
<div class="row">
  <div class="col-md-2"></div>
  <div class="col-md-8 col-12">
    <div class="card">
      <div class="card-body text-center">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="alert alert-success text-center" role="alert">
              Account Created/Updated Successfully.
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-9 offset-md-3">
            <div class="form-group row text-right">
              <label for="inputFirstName" class="col-md-3 col-4 col-form-label">First Name:</label>
              <div class="col-md-5 col-8 text-left" style="margin-top:0.5rem">
                <p> {{user.firstName}}</p>
              </div>
            </div>
            <div class="form-group row  text-right">
              <label for="inputLastName" class="col-md-3 col-4 col-form-label">Last Name:</label>
              <div class="col-md-5 col-8 text-left" style="margin-top:0.5rem">
                <p> {{user.lastName}}</p>
              </div>
            </div>
            <div class="form-group row text-right">
              <label for="inputEmail" class="col-md-3 col-4 col-form-label">Email:</label>
              <div class="col-md-5 col-8 text-left" style="margin-top:0.5rem">
                <p> {{user.email}}</p>
              </div>
            </div>

            <div class="form-group row text-right">
              <label for="inputRoles" class="col-md-3 col-4 col-form-label">Role(s):</label>
              <div class="col-md-5 col-8 text-left " style="padding-top:0.5rem">
                <div *ngFor="let role of user.roles">{{role}}</div>
              </div>
            </div>
            <div class="form-group row text-right">
              <label for="inputActive" class="col-md-3 col-4 col-form-label">Active:</label>
              <div class="col-md-5 col-8 text-left " style="padding-top:0.5rem">
                <p *ngIf="user.isEnabled"> Yes</p>
                <p *ngIf="!user.isEnabled"> No</p>
              </div>
            </div>
            <div class="form-group row text-right">
              <label for="inputLocked" class="col-md-3 col-4 col-form-label">Locked:</label>
              <div class="col-md-5 col-8 text-left " style="padding-top:0.5rem">
                <p *ngIf="user.isLockedOut"> Yes</p>
                <p *ngIf="!user.isLockedOut"> No</p>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-3 offset-md-1 odp-xs-button-margin-top btn-toolbar">
            <button id="createBtn"
                    type="button"
                    *ngIf="isAdmin"
                    class="btn btn-info btn-block"
                    (click)="goToNewUser()">
              Create New Account
            </button>
          </div>
          <div class="col-md-3 odp-xs-button-margin-top">
            <button id="returnBtn"
                    type="submit"
                    *ngIf="isAdmin"
                    class="btn btn-primary btn-block"
                    (click)="goToSearch()">
              Return to Manage Accounts
            </button>
          </div>
          <div class="col-md-3 odp-xs-button-margin-top  btn-toolbar">
            <button type="submit"
                    *ngIf="isAdmin"
                    class="btn btn-danger btn-block"
                    (click)="goToEditUser(user.id)">
              Edit User
            </button>
          </div>
          <div class="col-md-3 odp-xs-button-margin-top  btn-toolbar">
            <button type="submit"
                    *ngIf="!isAdmin"
                    class="btn btn-danger btn-block"
                    (click)="goToMe()">
              Edit User
            </button>
          </div>
        </div>
        <br />
      </div>
    </div>
  </div>
</div>
